// Shared by legacy buttons and Ant Design actions; callers control width and color.
export const ACTION_BUTTON_CLASSES = [
  '!inline-flex !items-center !justify-center !min-h-[46px] !h-[46px]',
  '!rounded-[10px] !px-sm !text-[14px] !font-semibold !leading-[20px]',
  'transition-shadow focus-visible:outline-primary',
].join(' ')

export const INSURANCE_MENU_CLASSES = [
  'flex min-h-[54px] w-full items-center justify-center text-center',
  'rounded-[12px] border border-solid border-accent !bg-accent bg-[linear-gradient(110deg,#fe7a24,#f06412)]',
  'px-ss py-xs text-[16px] font-semibold leading-snug !text-white',
  'shadow-[0_4px_18px_rgba(254,122,36,0.28)] transition-shadow',
  'hover:shadow-[0_6px_24px_rgba(254,122,36,0.4)] focus-visible:outline-primary',
].join(' ')
